import { render, staticRenderFns } from "./instructions-panel.vue?vue&type=template&id=25d8cafa&"
import script from "./instructions-panel.vue?vue&type=script&lang=ts&"
export * from "./instructions-panel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports